module.exports = __webpack_public_path__ + "media/images/icons/warning-code-info-b7a0f87116d9d0070b4589730fdaf3ed.svg";